const masterEn = {
    country: require('../../lang/en/master/Country').default,
    state: require('../../lang/en/master/State').default,
    city: require('../../lang/en/master/City').default,
    department: require('../../lang/en/master/Department').default,
    designation: require('../../lang/en/master/Designation').default,
    location: require('../../lang/en/master/Location').default,
    component: require('../../lang/en/master/Component').default,
    make: require('../../lang/en/master/Make').default,
    equipment: require('../../lang/en/master/Equipment').default,
    objectCondition: require('../../lang/en/master/ObjectCondition').default,
    object: require('../../lang/en/master/Object').default,
};

export default masterEn;